import { useLocation } from '@reach/router';

export const useIsPrivateRoute = () => {
  const location = useLocation();
  const PRIVATE_ROUTES = ['/account', '/checkout'];
  return PRIVATE_ROUTES.some(route => location.pathname.startsWith(route));
};
